import { Link } from "@tanstack/react-router";
import { ArrowLeft, ChevronRight } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  to?: string;
  params?: Record<string, string>;
}

export function BlogBreadcrumb({ items }: { items: BreadcrumbItem[] }) {
  // Find the last item that has a link (for mobile back-link)
  const backItem = [...items].reverse().find((item) => item.to);

  return (
    <>
      {/* Mobile: single back-link to parent */}
      {backItem && (
        <nav aria-label="Breadcrumb" className="sm:hidden">
          <Link
            to={backItem.to!}
            params={backItem.params}
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            {backItem.label}
          </Link>
        </nav>
      )}

      {/* Desktop: full breadcrumb trail */}
      <nav
        aria-label="Breadcrumb"
        className="hidden items-center gap-1.5 overflow-hidden text-sm text-muted-foreground sm:flex"
      >
        <Link
          to="/"
          className="shrink-0 transition-colors hover:text-foreground"
        >
          Toolverse
        </Link>
        {items.map((item, i) => (
          <span key={i} className="flex min-w-0 items-center gap-1.5">
            <ChevronRight className="h-3 w-3 shrink-0 opacity-40" />
            {item.to ? (
              <Link
                to={item.to}
                params={item.params}
                className="shrink-0 transition-colors hover:text-foreground"
              >
                {item.label}
              </Link>
            ) : (
              <span className="truncate text-foreground/80">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}
